import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { ModalHeader, ModalBody, Button,  } from 'reactstrap';
import TableGenerator from '../../../../../components/TableGenerator/TableGenerator';
import ModalWrapper from '../../../../../components/RootModal/ModalWrapper';
import { dateFormat } from '../../../../../utilities/dates';

import { closeModal, openToaster } from '../../../../../store/actions';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

const NotifyHistoryModal = (props) => {
  const idToken = useSelector(state => state.auth.idToken);
  const [inProgress, setInProgress] = useState(false)
  const resetReportLinks = async () => {
    try {
      setInProgress(true);
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/participants/parentAuthCode`,
        method: 'POST',
        data: {
          participants: [
            {
              surveyParticipantId: props.item.surveyParticipantId
            },
          ],
        },
        headers: { Authorization: idToken },
      });
      setInProgress(false);
      if (response.status === 200) {
        props.openToaster("Successfully reset parent report link. Previously sent links are disabled.")
        await props.refreshData();
      }
    } catch (error) {
      setInProgress(false);
      props.openToaster(`Error: ${error.message}`)
    }
  }

  const generateTableData = () => {
    if (props.notificationAttempts && props.notificationAttempts.length > 0) {
      let sortedNotifications = props.notificationAttempts;
      sortedNotifications.sort((n, m) => { return n.timestamp - m.timestamp });
      const result = sortedNotifications.map((logEntry) => {
        return {
          date: moment(logEntry.timestamp).format(`${dateFormat} hh:mm`),
          recipient: logEntry.destinationEmail? logEntry.destinationEmail.split(/\s*,\s*/).join(", ") : '-',
          status: logEntry.messageStatus,
          type: logEntry.type
        }
      })
      return result;
    }
    return [];
  }

  return (
    <ModalWrapper
      className='edit-participant-modal-wrapper'
      show={props.show}
      onExited={props.closeModal}
      size="lg"
    >
      <ModalHeader toggle={props.closeModal}>
        Notification History - {props.item.firstName} {props.item.lastName}
      </ModalHeader>
      <ModalBody bsPrefix='modalContent edit-participant-modal'>
        <TableGenerator
          config={{
            headers: ['DATE', 'RECIPIENT', 'STATUS', 'TYPE'],
            contentRows: generateTableData(),
          }}
        />
        <Button color='danger' disabled={inProgress} onClick={resetReportLinks}><FontAwesomeIcon className={inProgress ? 'fa-spin': ''} icon={faRefresh}/> Reset report links</Button>
      </ModalBody>
    </ModalWrapper>
  );
}

const mapStateToProps = state => {
  return {
    notificationAttempts: state.surveyCrud.notificationAttempts
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => dispatch(closeModal()),
    openToaster: (content, variant) => dispatch(openToaster(content, variant))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotifyHistoryModal);
